// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
import {
  DefaultPage,
  BasicMessageList,
  CompanyMessage,
  Frui_pfbzPage,
  Frui_zzzzPage,
  Frui_pfxhPage,
  Frui_qpbzPage,
  Frui_qpfjPage,
  Frui_qpxhPage,
  FruiTempFilePage,
  Frui_qppzPage
} from './';

export default {
  path: 'user',
  name: 'User',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'basicMessageList', name: 'Basic message list', component: BasicMessageList },
    { path: 'CompanyMessage', name: 'Company message', component: CompanyMessage },
    { path: 'Frui_pfbzPage', name: 'pfbzPage', component: Frui_pfbzPage },
    { path: 'Frui_zzzzPage', name: 'zzzzPage', component: Frui_zzzzPage },
    { path: 'Frui_pfxhPage', name: 'pfxhPage', component: Frui_pfxhPage },
    { path: 'Frui_qpbzPage', name: 'qpbzPage', component: Frui_qpbzPage },
    { path: 'Frui_qpfjPage', name: 'qpfjPage', component: Frui_qpfjPage },
    { path: 'Frui_qpxhPage', name: 'qpxhPage', component: Frui_qpxhPage },
    { path: 'Frui_qppzPage', name: 'qppzPage', component: Frui_qppzPage },
    { path: '/user/tempfile', name: 'Frui temp file page', component: FruiTempFilePage }
  ],
};



// WEBPACK FOOTER //
// ./src/features/user/route.js